module.exports = __webpack_public_path__ + "static/img/h5light.0ec07ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/matching/h5light.png
// module id = LHu3
// module chunks = 119